import { Slide as API } from '@src/api/types';
import { Slide as Data } from '@src/types';

import generateMedia from './media';

const Factory = (api: API): Data => ({
  id: api.id,
  entityId: api.value,
  entityType: api.type,
  cover: generateMedia(api.cover),
});

export default Factory;
